import { Grid, MenuItem } from '@mui/material';
import { CustomSelect, CustomTextField, HeaderFilterBox } from '../../../common';
import { CONSUMPTION_STATUS_LABELS } from '../constants/consumptionsConstants';
import { getWarehouseLabelFromRecord } from '../../internal-orders/utils/internalOrdersUtils';

const ConsumptionsFilters = ({
  filters,
  warehouses = [],
  onFilterChange,
  onSelectChange,
}) => {
  return (
    <HeaderFilterBox variant="twoRows">
      <Grid container spacing={2}>
        <Grid item xs={12} md={2.5}>
          <CustomSelect
            label="Estado"
            name="status"
            value={filters.status}
            onChange={onSelectChange}
            displayEmpty
            fullWidth
          >
            <MenuItem value="">Todos los estados</MenuItem>
            {Object.entries(CONSUMPTION_STATUS_LABELS).map(([value, label]) => (
              <MenuItem key={value} value={value}>
                {label}
              </MenuItem>
            ))}
          </CustomSelect>
        </Grid>
        <Grid item xs={12} md={2.5}>
          <CustomSelect
            label="Depósito"
            name="uuid_warehouse"
            value={filters.uuid_warehouse}
            onChange={onSelectChange}
            displayEmpty
            fullWidth
          >
            <MenuItem value="">Todos los depósitos</MenuItem>
            {warehouses.map((warehouse) => (
              <MenuItem key={warehouse.uuid} value={warehouse.uuid}>
                {getWarehouseLabelFromRecord(warehouse)}
              </MenuItem>
            ))}
          </CustomSelect>
        </Grid>
        <Grid item xs={12} md={3}>
          <CustomTextField
            label="Pedido técnico"
            name="order_number"
            value={filters.order_number}
            onChange={onFilterChange}
            placeholder="Ej: PT-000001"
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <CustomTextField
            label="Desde"
            name="date_from"
            type="date"
            value={filters.date_from}
            onChange={onFilterChange}
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <CustomTextField
            label="Hasta"
            name="date_to"
            type="date"
            value={filters.date_to}
            onChange={onFilterChange}
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
        </Grid>
      </Grid>
    </HeaderFilterBox>
  );
};

export default ConsumptionsFilters;
